module.exports = __webpack_public_path__ + "static/media/loading.7ee461ea.svg";